import { createStore } from '@stencil/store';

import type { NotificationContent, NotificationMode, Layout, MiniOverlayConfig } from './types';
import type { HighlightableElement } from '../acquisition-overlay/components/clickable-element';

export type NotificationState = {
  mode: NotificationMode;
  account: string;
  overlayId: string;
  content: NotificationContent;
  layout: Layout | Record<string, never>;
  preventHighlight: boolean;
  isMobileViewport: boolean;
  highlightElement: HighlightableElement | null;
  shadowRoot: ShadowRoot;
  // Mini overlay feature state
  showMiniOverlay: boolean;
  miniOverlayConfig: MiniOverlayConfig | null;
  shouldShowMiniOverlayFirst: boolean;
};

const { state, on, ...rest } = createStore<NotificationState>(() => ({
  mode: 'live',
  content: null,
  layout: { name: 'default' },
  account: null,
  overlayId: null,
  preventHighlight: false,
  isMobileViewport: false,
  highlightElement: null,
  shadowRoot: null,
  // Mini overlay feature state
  showMiniOverlay: false,
  miniOverlayConfig: null,
  shouldShowMiniOverlayFirst: false,
}));

export default state;
export const store = { on, ...rest };
